module.exports = __webpack_public_path__ + "static/media/icon-preapproval-declined.baed0275.svg";